<template>
  <div class="alert alert-success">
    <img src="/static/images/verified.png" />
    <div class="content">
      <p>{{ $t('title') }}</p>
      <p class="small">{{ $t('message', {company: companyName, epc: gs1Id}) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gs1AlertVerified',
  props: ['companyName', 'gs1Id'],
  i18n: {
    messages: {
      de: {
        title: 'Complete data',
        message: 'Die EAN/GTIN bzw. GLN {epc} ist unter {company} registriert.'
      },
      en: {
        title: 'Complete data',
        message: 'The EAN/GTIN or GLN {epc} is registered to {company}.'
      }
    }
  }
}
</script>

<style scoped>
.toolkit .alert {
  padding: 20px;
  margin-bottom: 46px;
}
.toolkit .alert img {
  float: left;
}
.toolkit .alert .content {
  margin-left: 67px;
}
.toolkit .alert .content p {
  color: var(--gs1-blue);
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}
.toolkit .alert .content p.small {
  color: var(--gs1-dark-gray);
  font-size: 20px;
  font-weight: normal;
  margin-top: 6px;
}
@media (max-width: 575.98px) {
  .toolkit .alert {
    margin-left: -15px;
    margin-right: -15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alerts/Gs1AlertVerified.vue